module.exports = __webpack_public_path__ + "static/media/sign-up-img-6_mobile.d9ee2624.png";